import { BaseAction } from './BaseAction';
import Locale from '../../utils/Locale';
import * as Alert from '../../alert';

let alertTypes = {};
for (let cls of Object.values(Alert.Types)) {
    if (!cls.type || cls.type.length === 0)
        continue;
    let types = Array.isArray(cls.type) ? cls.type : [cls.type];
    for (let type of types) {
        let title = Array.isArray(cls.type) ? 
            cls.title[types.indexOf(type)] : 
            cls.title;
        if (cls) {
            alertTypes[type] = title;
        } 
    }
}

export class AlertCreated extends BaseAction {
    public static getTitle:Function = () => Locale.gettext('New Alert');
    public static getDescription:Function = () => Locale.gettext('When a new alert is created');
    public static deviceLevel:boolean = true;
    public static categories: { [key: string]: string; } = Alert.AlertCategories;
    public static types: { [key: string]: string; } = alertTypes;
    public static supportedRoutes:string[] = [ "push", "email" ];
}